<template>
  <div>
    <div class="spcore-box hvh-flex column p-4">
      <h2 class="hvh-h4">{{ title }}</h2>
      <div class="hvh-flex column space-evenly grow-1 mt-3">
        <div class="hvh-flex center">
          <img :src="image" style="width: 55px" v-if="image" />
        </div>
        <div class="hvh-flex column align-center mt-3" v-for="(item, ind) in data" :key="ind">
          <h2 class="hvh-h2 position-relative">
            {{ item.value || '-' }}
            <v-icon class="hvh-edit-position px-0" small style="position: aboslute; top: -5px; right: -15px; color: red" v-if="item.alert">mdi-alert-circle-outline</v-icon>
          </h2>
          <h2 class="hvh-h6">{{ item.text }}</h2>
          <div class="p-3 my-4" style="background-color: #8ccac8" v-if="ind === 0 && message">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
    <loader v-if="isFiltering" />
  </div>
</template>

<script>
export default {
  noExport: true,
  props: ['title', 'data', 'isFiltering', 'image', 'message'],
  mounted() {
    this.$emit('refresh-data');
  },
}
</script>
